import React from "react";
import { Link } from "react-router-dom";

export default function ExpertSubscribeModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative animate-fade-in">
        <button
          className="absolute top-3 right-3 text-green-700 hover:text-green-900 text-xl"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <div className="flex flex-col items-center">
          <svg className="w-14 h-14 text-green-600 mb-3" fill="none" viewBox="0 0 24 24">
            <path d="M12 2l3 7h7l-5.5 4.3 2 7L12 16l-6.5 4.3 2-7L2 9h7l3-7z" stroke="#22c55e" strokeWidth="1.8" fill="#bbf7d0" />
          </svg>
          <h2 className="text-2xl font-bold text-green-800 mb-1 text-center">
            Expert Access Required
          </h2>
          <p className="text-green-700 text-center mb-4">
            Only <b>Choir Expert</b> subscribers can download or preview music books.<br />
            Upgrade now for unlimited downloads and exclusive resources!
          </p>
          <Link
            to="/subscribe"
            className="mt-2 inline-block px-7 py-3 bg-gradient-to-r from-green-700 to-lime-500 text-white font-bold rounded-xl shadow hover:from-green-800 hover:to-lime-600 transition"
            onClick={onClose}
          >
            Upgrade to Choir Expert
          </Link>
        </div>
      </div>
    </div>
  );
}
